import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Grid, Header, Button, Icon } from 'semantic-ui-react'
import { FormValidation, Field } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { createCompany, updateCompany } from '../../common/companies/actions'
import {
  validateCreate,
  validateUpdate,
} from '../../common/companies/validations'

const { Row, Column } = Grid

const emailsToArray = (text) => {
  const removedWhiteSpace = text.replace(/\s/g, '')
  const splitByComma = removedWhiteSpace.split(',')
  if (splitByComma.length > 1) return splitByComma
  const splitBySemi = removedWhiteSpace.split(';')
  if (splitBySemi.length > 1) return splitBySemi
  if (!removedWhiteSpace) return []
  return [removedWhiteSpace]
}

class CompanyForm extends React.Component {
  componentWillUnmount() {
    this.props.fields.$reset()
  }

  async submit(e) {
    e.preventDefault()
    const { fields, submit, company, createCompany, updateCompany } = this.props
    const isUpdate = company && !!company._id
    const values = fields.$values()
    let submissionFunction = createCompany

    values.drivingLicenseExpirationEmails = emailsToArray(values.dleEmails)
    values.medicalExamExpirationEmails = emailsToArray(values.meeEmails)
    values.adrExpirationEmails = emailsToArray(values.adreEmails)
    values.trainingExpirationEmails = emailsToArray(values.teEmails)

    if (isUpdate) {
      values._id = company._id
      submissionFunction = updateCompany
    }
    if (await submit(values, submissionFunction) !== false) {
      fields.$reset()
    }
  }

  render() {
    const { fields, errors, company, submitting, submitSuccessfull } = this.props
    if (submitSuccessfull) return <Redirect to="/companies" />

    const fieldErrors = {}
    errors.filter(e => e.detail && e.detail.field).forEach(error => {
      fieldErrors[error.detail.field] = error.message
    })
	
    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Základní údaje</Header>
            </Column>
          </Row>
          <Field label="Název dopravce" {...fields.name} required error={fieldErrors.name} />
        </Grid>

        <Grid>
          <Row>
            <Column>
              <Header as="h2">Kontakty pro expiraci</Header>
            </Column>
          </Row>
          <Field type="checkbox" label="Zasílat oznámení" {...fields.canNotify} />
          <Field label="Řidičský průkaz" {...fields.dleEmails} error={fieldErrors.drivingLicenseExpirationEmails} />
          <Field label="Lékařská prohlídka" {...fields.meeEmails} error={fieldErrors.medicalExamExpirationEmails} />
          <Field label="Školení" {...fields.teEmails} error={fieldErrors.trainingExpirationEmails} />
          <Field label="ADR" {...fields.adreEmails} error={fieldErrors.adrExpirationEmails} />
        </Grid>
		
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Tělo oznámení</Header>
            </Column>
          </Row>
		  <Field label="Řidičský průkaz" type="textarea" {...fields.drivingLicenseExpirationBody} />
		  <Field label="Lékařská prohlídka" type="textarea" {...fields.medicalExamExpirationBody} />
		  <Field label="Školení" type="textarea" {...fields.trainingExpirationBody} />
		  <Field label="ADR" type="textarea" {...fields.adrExpirationBody} /> 
        </Grid>
		
        <Grid>
          <Field type="checkbox" label="Vyřazený dopravce" {...fields.archived} />
          {company && company.archived &&
          <Row columns={2}>
            <Column><Icon color="red" name="remove" /> Vyřazen:</Column>
            <Column>{moment(fields.archivedAt.value).format('D.M.YYYY HH:mm')}</Column>
          </Row>
          }
          <Row>
            <Column>
              <Button type="submit" onClick={(e) => this.submit(e)}>Uložit</Button>
            </Column>
          </Row>
        </Grid>
      </Form>
    )
  }
}

CompanyForm.defaultProps = {
  company: null,
  errors: [],
  submitting: false,
  submitSuccessfull: false,
}

CompanyForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  company: React.PropTypes.object,
  errors: React.PropTypes.array,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
}

CompanyForm = fields(CompanyForm, {
  path: 'CompanyForm',
  fields: ['name', 'canNotify', 'dleEmails', 'meeEmails', 'adreEmails', 'teEmails', 'archived','archivedAt',
	'drivingLicenseExpirationBody','medicalExamExpirationBody', 'trainingExpirationBody','adrExpirationBody',
  ],
  getInitialState: (props) => {
    const { company } = props
    if (company && company._id) {
      const companyObject = company.toJS()
      companyObject.dleEmails = companyObject.drivingLicenseExpirationEmails.join('; ')
      companyObject.meeEmails = companyObject.medicalExamExpirationEmails.join('; ')
      companyObject.adreEmails = companyObject.adrExpirationEmails.join('; ')
      companyObject.teEmails = companyObject.trainingExpirationEmails.join('; ')
      return companyObject
    }
    return {}
  },
})

CompanyForm = FormValidation(CompanyForm, (props) => {
  const { company } = props
  let submissionValidation
  if (company && company._id) submissionValidation = validateUpdate
  else submissionValidation = validateCreate
  return { submissionValidation }
})

export default connect(() => ({}), { createCompany, updateCompany })(CompanyForm)



// WEBPACK FOOTER //
// ./src/browser/forms/Company.js